import { Controller } from "@hotwired/stimulus";
import { useStore } from "stimulus-store";
import { sendFailureNotification, sendSuccessNotification } from "shared/toast_notifications";
import { getCsrfToken } from "shared/form_helpers";
import { allBundlesStore } from "../../../stores/device_types/all_bundles_store";

// Connects to data-controller="forms--bundle--create-bundle-form"
export default class extends Controller {

    static stores = [
        allBundlesStore
    ]

    static targets = [
        'form',
        'name',
        'icon',
        'models',
        'parts',
        'submitButton'
    ];

    connect() {
        useStore(this);

        // Prevent default form submission
        if (this.hasFormTarget) {
            this.formTarget.addEventListener('submit', (e) => e.preventDefault());
        }
    }

    async submit(event) {
        event.preventDefault();

        // Disable submit button to prevent double submission
        this.submitButtonTarget.disabled = true;

        try {
            // Gather form data
            const formData = {
                name: this.nameTarget.value,
                icon: this.iconTarget.value || null,
                models: this.modelsTarget.tomselect ? this.modelsTarget.tomselect.items : [],
                parts: this.partsTarget.tomselect ? this.partsTarget.tomselect.items : []
            };

            // Make API request
            const response = await fetch('/api/device_types/bundle/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': getCsrfToken()
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (response.ok && result.status === 'success') {
                // Add the new bundle to the store
                const newBundle = result.data;
                const currentBundles = this.allBundlesStoreValue || [];
                this.setAllBundlesStoreValue([...currentBundles, newBundle]);

                // Show success notification
                sendSuccessNotification(`Successfully created the ${newBundle.name} bundle`);

                // Clear the form
                this.clearForm();
            } else {
                // Show error notification
                const errorMessage = result.message || 'Failed to create bundle. Please try again.';
                sendFailureNotification(errorMessage);
            }
        } catch (error) {
            console.error('Error creating bundle:', error);
            sendFailureNotification('An error occurred while creating the bundle. Please try again.');
        } finally {
            // Re-enable submit button
            this.submitButtonTarget.disabled = false;
        }
    }

    clearForm() {
        // Clear text inputs
        this.nameTarget.value = '';

        // Clear icon select (uses fontIconPicker, not tomselect)
        if (this.hasIconTarget && typeof $.fn.fontIconPicker === 'function') {
            $(this.iconTarget).fontIconPicker().setIcon('');
        }

        // Clear models select
        if (this.modelsTarget.tomselect) {
            this.modelsTarget.tomselect.clear();
        }

        // Clear parts select
        if (this.partsTarget.tomselect) {
            this.partsTarget.tomselect.clear();
        }
    }
}